import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-打回",
  "use": "icon-打回-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-打回\"><path d=\"M378.24 767.488A32 32 0 0 1 384 704h288a160 160 0 0 0 10.496-319.68L672 384H320V320h352a224 224 0 0 1 0 448H384z\" fill=\"#5C5F73\" p-id=\"4291\" /><path d=\"M154.048 335.744L364.416 204.16a12.8 12.8 0 0 1 19.584 10.88v273.792a12.8 12.8 0 0 1-19.584 10.88L154.048 368.256a19.2 19.2 0 0 1 0-32.512z\" fill=\"#5C5F73\" p-id=\"4292\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol